export default "__VITE_ASSET__ComxN6C7__"